/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const breakpoints = {
  values: {
    xs: 0,
    sm: 320,
    md: 768,
    lg: 1024,
    xl: 1366,
    xl1: 1440,
    xl2: 1600,
    xl3: 1920,
    xl4: 2560,
  },
};
